<template>
    <a-layout-header class="header">
        <slot name="head"></slot>
        <div class="site-brand">
            <a href="/">
                <img src="/favicon.ico" alt="H5mota">
                <div class="logo">
                    <span class="h5mota">H5mota</span>
                </div>
            </a>
        </div>
        <slot name="center"></slot>
        <div v-if="hasLogin" class="user">
            <a href="/user/my">
                <a-avatar :src="avatarURL" shape="square" />
                <span class="username">{{ username }}</span>
            </a>
        </div>
        <div v-else class="unlogin">
            <a @click="handleLogin">登录</a> | <a href="/user/register.html" target="_blank">注册</a>
        </div>
        <a-modal title="登录" width="360px"
            :visible="loginDialogVisible" on-ok="confirm" on-cancel="cancel"
        >
            <a-form-model :model="form" :rules="rules" ref="loginForm">
                <a-form-model-item label="账号">
                    <a-input v-model="form.username"></a-input>
                </a-form-model-item>
                <a-form-model-item label="密码">
                    <a-input v-model="form.password" type="password"></a-input>
                </a-form-model-item>
            </a-form-model>
            <a class="el-link" href="/user/register.html" target="_blank">没有账号? 去注册</a>
            <template slot="footer">
                <a-button key="submit" type="primary" :loading="isLogining"
                    @click="confirm"
                >登录</a-button>
            </template>
        </a-modal>
        <slot name="tail"></slot>
    </a-layout-header>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    data() {
        return {
            form: {
                username: "",
                password: ""
            },
            isLogining: false,
            rules: {
                username: [
                    { required: true, message: '请输入用户名' }
                ],
                password: [
                    { required: true, message: '请输入密码' }
                ],
            }
        }
    },
    computed: {
        ...mapState([
            "loginDialogVisible", "avatarURL", "username", "hasLogin", "userid"
        ]),
    },
    methods: {
        ...mapMutations([ "closeLoginDialog" ]),
        ...mapActions([ "openLoginDialog", "doLogin" ]),
        handleLogin() {
            this.openLoginDialog().then(() => {
                if (this.hasLogin) {
                    window.location.reload();
                }
            });
        },
        confirm() {
            this.$refs.loginForm.validate(async(valid) => {
                if (valid) {
                    this.isLogining = true;
                    const res = await this.doLogin(this.form);
                    this.isLogining = false;
                    if (res.code == 0) {
                        this.closeLoginDialog();
                    } else {
                        this.$message.error("登录失败");
                    }
                }
            })
        },
        cancel() {
            this.closeLoginDialog();
        },
    }
}
</script>

<style lang="less" scoped>
@font-face {
    font-family: TypoRound;
    font-weight: normal;
    src: url(/assets/Typo_Round_Regular.1a899395b.otf) format('opentype');
}
header {
    display: flex;
    padding: 5px 15px;
    box-shadow: 0px 1px 12px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 1;
}
.site-brand, .site-brand a {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 30px;
    text-decoration: none;
    align-items: center;
    align-self: center;
    img {
        height: 30px;
    }
    .logo {
        color: white;
        font-weight: 300;
        padding-left: 10px;
        font-size: 20px;
        font-family: TypoRound, sans-serif;
    }
}
.user {
    display: flex;
    align-items: center;
    margin-left: auto;
    cursor: pointer;
    .username {
        color: #BBBBBB;
        margin-left: 5px;
    }
}
.unlogin {
    display: flex;
    align-items: center;
    color: #888888;
    margin-left: auto;
    a {
        color: #888888;
        margin: 1px 4px 0;
        &:hover {
            color: #1890ff;
        }
    }
}
</style>